import { render, staticRenderFns } from "./airValve.vue?vue&type=template&id=2863c3ce&scoped=true"
import script from "./airValve.vue?vue&type=script&lang=js"
export * from "./airValve.vue?vue&type=script&lang=js"
import style0 from "./airValve.vue?vue&type=style&index=0&id=2863c3ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2863c3ce",
  null
  
)

export default component.exports